import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services } from "@/data/services";

export function ServicesSection() {
  return (
    <section id="services" className="relative py-24 lg:py-32 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-3">
              What We Move
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tight max-w-2xl">
              A full-service logistics operation built around your schedule.
            </h2>
          </div>
          <Link
            to="/quote"
            className="text-sm uppercase tracking-wider font-bold text-primary-brand hover:text-slate-900 flex items-center gap-2"
          >
            Discuss your shipment <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.05, duration: 0.5 }}
              className="group bg-brand-bg hover:bg-white p-8 lg:p-10 transition-colors relative"
              data-testid={`service-card-${i}`}
            >
              <s.icon className="h-8 w-8 text-primary-brand mb-6" strokeWidth={1.5} />
              <h3 className="font-heading text-xl font-bold mb-3">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              <div className="mt-6 h-px w-8 bg-primary-brand transition-all group-hover:w-16" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
